<template>
<div class="reg-pop-wrap" :class="{mb: mb}">
    <div class="toast"></div>
    <div class="txt-wrap">
        <div class="reg-content">
            {{ txt }}
        </div>
        <div class="btn" @click="clickPop()" >{{ $t($loginLangPrefix('userSign.ok')) }}</div>
    </div>
</div>
</template>
<script>

export default {
    name: 'popwrap',
    props: {
        txt: { type: String, default: '' },
        mb: { type: String, default: '' }
    },
    data() {
        return {
        };
    },
    components: {
    },
    methods: {
        clickPop() {
            this.$emit('clickPop');
        }
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.reg-pop-wrap {
    position: fixed;
    z-index: 1000;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    box-sizing: border-box;
    .toast {
        position: absolute;
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,1);
        opacity:0.7;
    }
    .txt-wrap {
        position: absolute;
        width: rem(303);
        height: rem(180);
        left: 50%;
        margin-left: rem(-151);
        top: 50%;
        margin-top: rem(-90);
        padding: rem(20) rem(18);
        box-sizing: border-box;
        font-family: 'RobotoRegular';
        font-weight: 400;
        background: rgba(255,255,255,1);
        border-radius: rem(18);
        .reg-content {
            margin-top: rem(10);
            font-size: 16px;
            font-family: 'RobotoMedium';
            font-weight:500;
            color:rgba(23,23,23,1);
            line-height:rem(19);
            text-align: center;
            min-height: 1rem;
        }
        .btn {
            position: relative;
            width: 100%;
            height: rem(48);
            line-height: rem(48);
            background:rgba(157,29,255,1);
            border-radius: rem(24);
            margin-top: rem(20);
            font-size:16px;
            font-family: 'RobotoMedium';
            font-weight:500;
            color:rgba(255,255,255,1);
            text-align: center;
        }
    }
    // width:200px;
    // height:49px;
    // background:rgba(0,0,0,1);
    // border-radius:8px;
    // opacity:0.7;
}
</style>
